/* eslint-disable react/prop-types */
import React from 'react';
import { _RoundedBox } from "../../style/CommonStyles";
import { _NormalPrice } from "../styles";
import useInitialProps from "../../../hooks/useInitialProps";
import { formatCurrency } from '@applyboard/ui-utils';
import { currencyObjectSelector } from "../../../util/currency";
var NormalPrice = function NormalPrice(_ref) {
  var charge = _ref.charge,
    chargeTitleTip = _ref.chargeTitleTip;
  var _useInitialProps = useInitialProps(),
    currencies = _useInitialProps.currencies;
  return /*#__PURE__*/React.createElement(_RoundedBox, {
    "data-tip": chargeTitleTip,
    canceled: charge.canceled,
    refunded: charge.refunded
  }, /*#__PURE__*/React.createElement(_NormalPrice, {
    canceled: charge.canceled || charge.refunded
  }, formatCurrency(charge.price, currencyObjectSelector(currencies, charge.currency))));
};
export default NormalPrice;